const messages = {
    'en-US' : {
        message: {
            signin: 'Sign In',
            email : "Email",
            password : "Password",
            forgotPassword : "Forgot Your Password?",
            confirmpassword : "Confirm password",
            confirmyourpassword : "Confirm your password",
            enteryourpassword : "Enter your password",
            loginlabelwithotphone : "Enter your email",
            createnewaccount: "Create a new account",
            accountcreated: "Account created successfully",
            unknownError: "Unknown error appeared. Please try again later"
        },

        button : {
            signin : 'Sign In',
            signup : 'Sign Up'
        }
    }
}

export default messages